// Network access is enforced by the existing Tailscale-only operator host.
export const OPERATOR_DASHBOARD_URL = 'https://operator-dashboard.dorado-perch.ts.net';

export function isMorfiMarketsEmail(email: string | null | undefined): boolean {
  return email?.trim().toLowerCase().endsWith('@morfi.markets') ?? false;
}
